import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass, withCtx as _withCtx, toHandlers as _toHandlers, withKeys as _withKeys, withModifiers as _withModifiers, mergeProps as _mergeProps, createVNode as _createVNode } from "vue"

const _hoisted_1 = ["part"]
const _hoisted_2 = { key: 0 }
const _hoisted_3 = { class: "mb-4 ext-attr-group" }
const _hoisted_4 = { class: "row" }
const _hoisted_5 = { class: "col-12" }
const _hoisted_6 = {
  key: 0,
  class: "px-3 py-2 fw-semibold text-muted bg-light border-bottom small sticky-top"
}
const _hoisted_7 = ["innerHTML"]
const _hoisted_8 = { class: "d-flex align-items-center" }
const _hoisted_9 = {
  key: 0,
  class: "me-2 flex-shrink-0",
  style: {"width":"2.5rem"}
}
const _hoisted_10 = ["src", "alt"]
const _hoisted_11 = {
  key: 1,
  class: "d-flex align-items-center justify-content-center rounded border bg-light text-muted",
  style: {"height":"2rem","font-size":"1rem"}
}
const _hoisted_12 = /*#__PURE__*/_createElementVNode("i", { class: "pis-icon pis-icon-image" }, null, -1)
const _hoisted_13 = [
  _hoisted_12
]
const _hoisted_14 = { class: "flex-grow-1 overflow-hidden" }
const _hoisted_15 = { class: "fw-bold text-truncate" }
const _hoisted_16 = {
  key: 0,
  class: "small text-muted text-truncate"
}
const _hoisted_17 = ["aria-expanded"]
const _hoisted_18 = { class: "d-flex align-items-center flex-grow-1 w-100" }
const _hoisted_19 = {
  key: 0,
  class: "me-2 flex-shrink-0",
  style: {"width":"2rem"}
}
const _hoisted_20 = ["src", "alt"]
const _hoisted_21 = {
  key: 1,
  class: "d-flex align-items-center justify-content-center rounded border bg-light text-muted",
  style: {"height":"1.5rem","font-size":"0.875rem"}
}
const _hoisted_22 = /*#__PURE__*/_createElementVNode("i", { class: "pis-icon pis-icon-image pis-icon-sm" }, null, -1)
const _hoisted_23 = [
  _hoisted_22
]
const _hoisted_24 = { class: "flex-grow-1 overflow-hidden" }
const _hoisted_25 = {
  key: 0,
  class: "text-truncate d-block"
}
const _hoisted_26 = { class: "fw-medium d-block text-truncate" }
const _hoisted_27 = {
  key: 0,
  class: "text-muted small d-block text-truncate"
}
const _hoisted_28 = {
  key: 1,
  class: "text-muted"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_InjectStyles = _resolveComponent("InjectStyles")!
  const _component_Clickable = _resolveComponent("Clickable")!
  const _component_Dropdown = _resolveComponent("Dropdown")!

  return (_openBlock(), _createElementBlock("div", {
    ref: "root",
    class: _normalizeClass(["pis-component", _ctx.componentName]),
    part: _ctx.componentName,
    id: "pis-anchor-variants-dropdown"
  }, [
    (_ctx.isReady && _ctx.visible)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
          (_ctx.isWebComponent)
            ? (_openBlock(), _createBlock(_component_InjectStyles, {
                key: 0,
                items: _ctx.store?.options.styles
              }, null, 8, ["items"]))
            : _createCommentVNode("", true),
          _createElementVNode("h4", null, _toDisplayString(_ctx.t('Variants')), 1),
          _createElementVNode("div", _hoisted_3, [
            _createElementVNode("div", _hoisted_4, [
              _createElementVNode("div", _hoisted_5, [
                _createVNode(_component_Dropdown, {
                  open: _ctx.isDropdownOpen,
                  "onUpdate:open": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.isDropdownOpen) = $event)),
                  width: "100%",
                  items: _ctx.dropdownItems
                }, {
                  item: _withCtx(({ item }) => [
                    (item.type === 'group')
                      ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
                          _createElementVNode("span", {
                            innerHTML: item.value.attributeName + ': ' + item.value.attributeValueText
                          }, null, 8, _hoisted_7)
                        ]))
                      : (item.type === 'product')
                        ? (_openBlock(), _createBlock(_component_Clickable, {
                            key: 1,
                            class: _normalizeClass(["dropdown-item py-2", {
                    active: item.value.productId === _ctx.selectedProduct?.productId,
                  }]),
                            onClick: ($event: any) => (_ctx.details(item.value))
                          }, {
                            default: _withCtx(() => [
                              _createElementVNode("div", _hoisted_8, [
                                (_ctx.componentOptions.showImages !== false)
                                  ? (_openBlock(), _createElementBlock("div", _hoisted_9, [
                                      (item.value.images?.length)
                                        ? (_openBlock(), _createElementBlock("img", {
                                            key: 0,
                                            src: item.value.images[0].thumbnailUrl,
                                            alt: _ctx.attrValue(item.value, '#DisplayName'),
                                            class: "img-fluid rounded border",
                                            style: {"max-height":"2rem","object-fit":"contain"},
                                            loading: "lazy"
                                          }, null, 8, _hoisted_10))
                                        : (_openBlock(), _createElementBlock("div", _hoisted_11, _hoisted_13))
                                    ]))
                                  : _createCommentVNode("", true),
                                _createElementVNode("div", _hoisted_14, [
                                  _createElementVNode("div", _hoisted_15, _toDisplayString(_ctx.attrValue(item.value, '#DisplayName')), 1),
                                  (_ctx.attrValue(item.value, 'CatalogDescription'))
                                    ? (_openBlock(), _createElementBlock("div", _hoisted_16, _toDisplayString(_ctx.attrValue(item.value, 'CatalogDescription')), 1))
                                    : _createCommentVNode("", true)
                                ])
                              ])
                            ]),
                            _: 2
                          }, 1032, ["class", "onClick"]))
                        : _createCommentVNode("", true)
                  ]),
                  activator: _withCtx(({ on }) => [
                    _createElementVNode("div", _mergeProps(_toHandlers(on, true), {
                      class: "form-select d-flex align-items-center",
                      tabindex: "0",
                      role: "combobox",
                      "aria-expanded": _ctx.isDropdownOpen,
                      "aria-haspopup": "listbox",
                      onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.toggleDropdown && _ctx.toggleDropdown(...args))),
                      onKeydown: [
                        _cache[1] || (_cache[1] = _withKeys(
//@ts-ignore
(...args) => (_ctx.toggleDropdown && _ctx.toggleDropdown(...args)), ["enter"])),
                        _cache[2] || (_cache[2] = _withKeys(_withModifiers(
//@ts-ignore
(...args) => (_ctx.toggleDropdown && _ctx.toggleDropdown(...args)), ["prevent"]), ["space"]))
                      ]
                    }), [
                      _createElementVNode("div", _hoisted_18, [
                        (_ctx.componentOptions.showImages !== false && _ctx.selectedProduct)
                          ? (_openBlock(), _createElementBlock("div", _hoisted_19, [
                              (_ctx.selectedProduct.images?.length)
                                ? (_openBlock(), _createElementBlock("img", {
                                    key: 0,
                                    src: _ctx.selectedProduct.images[0].thumbnailUrl,
                                    alt: _ctx.selectedProduct && _ctx.attrValue(_ctx.selectedProduct, '#DisplayName'),
                                    class: "img-fluid rounded border",
                                    style: {"max-height":"1.5rem","object-fit":"contain"}
                                  }, null, 8, _hoisted_20))
                                : (_openBlock(), _createElementBlock("div", _hoisted_21, _hoisted_23))
                            ]))
                          : _createCommentVNode("", true),
                        _createElementVNode("div", _hoisted_24, [
                          (_ctx.selectedProduct)
                            ? (_openBlock(), _createElementBlock("span", _hoisted_25, [
                                _createElementVNode("span", _hoisted_26, _toDisplayString(_ctx.attrValue(_ctx.selectedProduct, '#DisplayName')), 1),
                                (_ctx.attrValue(_ctx.selectedProduct, 'CatalogDescription'))
                                  ? (_openBlock(), _createElementBlock("span", _hoisted_27, " (" + _toDisplayString(_ctx.attrValue(_ctx.selectedProduct, 'CatalogDescription')) + ") ", 1))
                                  : _createCommentVNode("", true)
                              ]))
                            : (_openBlock(), _createElementBlock("span", _hoisted_28, _toDisplayString(_ctx.t('SelectProduct')), 1))
                        ])
                      ])
                    ], 16, _hoisted_17)
                  ]),
                  _: 1
                }, 8, ["open", "items"])
              ])
            ])
          ])
        ]))
      : _createCommentVNode("", true)
  ], 10, _hoisted_1))
}